export const errorCallback = (error) => {
  let alertBoxObject = {}
  if (error.status === 400) {
    const message = getMessage(error);
    if (message) {
      const title = message.split('<br>')[0];
      const html = message.split('<br>').slice(1).join('<br>');
      alertBoxObject = {
        title,
        html,
      };
    }
  } else if (error.status === 401) {
    alertBoxObject ={
      title: 'Unauthorised Access',
      text: 'Redirected user.',
    }
  } else if (error.status === 403) {
    alertBoxObject ={
      title: 'Forbidden Access',
      text: 'You don\'t have permission to access this resource.',
    }
  }
  setTimeout(() => {
    if (window.alertBox.isVisible()) {
      window.alertBox.update(alertBoxObject)  
    } else {
      window.alertBox.fire(alertBoxObject)  
    } 
  }, 300) // How long sweetalert animations are
  return
};

function getMessage (error) {
  let message = '';
  if (typeof error.data === 'string') {
    message += `${error.data}<br>`;
  }
  if (error.data.title) {
    message += `${error.data.title}<br>`;
  }
  if (error.data.message) {
    message += `${error.data.message}<br>`;
  }
  if (error.data.issues) {
    message += error.data.issues.join('<br>');
  }
  return message
}

export const successCallback = (operation, response) => {
  setTimeout(() => {
    if (!window.alertBox.isVisible()) {
      window.alertBox.fire({
        title: `${operation} Successful`,
        icon: 'success',
      });
    }
  }, 300) // How long sweetalert animations are
  return response
};
